import React, { PureComponent } from "react";
import { Form } from "@ant-design/compatible";
import "@ant-design/compatible/assets/index.css";
import { message, Modal, Button, Radio, Input, Select } from "antd";
import fetchHandler from "@/fetch/fetchHandler";
import ChooseStation from "./chooseStation";
import ChooseStubId from "./chooseStubId";
// 国际化切换语言
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import { upOrAddStubOpLog } from "../../../fetch/fetchApi";

const FormItem = Form.Item;

// eslint-disable-next-line arrow-parens
@connect(state => state)
class EditOrAddStuOpLogClass extends PureComponent {
  constructor(props) {
    super(props);
    console.info('囫：' + this.props.form.opType)
    this.state = {
      opTypeV:1,
      stubInfoData:null,
      stubIdData:null,
      sortTypeOption:JSON.parse(window.sessionStorage.getItem('sortTypeOption')),
      internationalization: this.props.intl.messages.EditOrAddStuOpLog,
    };
  }

  chooseAc = (e) => {
    console.info('数')
    console.info(e)
    this.setState({
      stubInfoData:e.name,
      statusLogVisible: false,
    });
    this.props.form.setFieldsValue({
      stationId: e.key
    });
  }

  chooseStubIdInfo = (e) => {
    console.info('数')
    console.info(e)
    this.setState({
      stubIdData:e.key,
      statusStubIdLogVisible: false,
    });
    this.props.form.setFieldsValue({
      stubId: e.key
    });
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        //巡检费用数值判断，设备型号长度判断
        if (values.opType == 2 && values.stubId.length > 50)
        {
          message.error('设备编号最大长度不能超过50个字符');
          return;
        }
        const number = /^(\-|\+)?\d+(\.\d+)?$/;
        if (values.payInfo && values.payInfo != null && !number.test(values.payInfo))
        {
          message.error('费用必须填写数值类型');
          return;
        }
        this.setState({
          btnLoading: true,
        });
        if (!this.props.stubId || this.props.stubId == null)
        {
          
        } else {
          values.id = this.props.stubId.key;
        }
        fetchHandler(upOrAddStubOpLog, {
          ...values,
        }).then((res) => {
          if (this.props.setSelectedRowKeysNull) {
            this.props.setSelectedRowKeysNull();
          }
          if (res && res.code === "success") {
            message.success(this.state.internationalization.msg1); // '操作成功');
            if (this.props.onCancel) {
              this.props.onCancel();
            }
            if (this.props.refreshGrid) {
              this.props.refreshGrid();
            }
          }
          this.setState({
            btnLoading: false,
          });
        });
      }
    });
  };
  
  render() {
    const { getFieldDecorator } = this.props.form;
    const tailFormItemLayout = {
      wrapperCol: {
        xs: { span: 24, offset: 0 },
        sm: { span: 16, offset: 5 },
      },
    };
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 30 },
        sm: { span: 15, offset: 1 },
      },
    };
    return (
      <div>
        <div>
        <Form onSubmit={this.handleSubmit}>

        <FormItem {...formItemLayout} label={this.state.internationalization.title6}>
              {getFieldDecorator("opType", {
                rules: [
                  {
                    required: true,
                    message: "请选择维修对象",
                  },
                ],
                initialValue: this.props.stubId == null ? '1' : this.props.stubId.opType + '',
              })(
              <Select disabled={(this.props.stubId && this.props.stubId != null && this.props.stubId.opType != null)} style={{ width: 100 }} onSelect={(value, option) => {
                console.info(value)
                console.info(option)
                this.setState({
                  opTypeV: value
                });
              }}>
                <Select.Option key="1" value="1">场站</Select.Option>
                <Select.Option key="2" value="2">设备</Select.Option>
            </Select>,
              )}
          </FormItem>

        {/* {(this.props.form.getFieldValue('opType') != null && this.props.form.getFieldValue('opType') == 2) ? (<FormItem {...formItemLayout} label={this.state.internationalization.title1}>
              {getFieldDecorator("stubId", {
                rules: [
                  {
                    required: true,
                    message: "请输入设备编号",
                  },
                ],
                initialValue: this.props.stubId == null ? null : this.props.stubId.stubId,
              })(<Input />)}
          </FormItem>) : null} */}

          {(this.props.form.getFieldValue('opType') != null && this.props.form.getFieldValue('opType') == 2) ? (<FormItem {...formItemLayout} label={this.state.internationalization.title1}>
              {getFieldDecorator("stubId", {
                rules: [
                  {
                    required: true,
                    message: "请选择设备编号",
                  },
                ],
                initialValue: this.props.stubId == null ? null : this.props.stubId.stubId,
              })(<div><span>{(this.state.stubIdData && this.state.stubIdData != null) ? this.state.stubIdData : ((this.props.stubId && this.props.stubId != null) ? this.props.stubId.stubId : '')}</span><Button type="link"
              onClick={(e) => {
                this.setState({
                  statusStubIdLogVisible: true,
                });
              }}>
              {(((this.state.stubInfoData && this.state.stubInfoData != null && this.state.stubInfoData != '')) || (this.props.stubId && this.props.stubId != null)) ? '修改' : '请选择'}
            </Button></div>)}
          </FormItem>) : null}

          {(this.props.form.getFieldValue('opType') != null && this.props.form.getFieldValue('opType') == 1) ? (<FormItem {...formItemLayout} label={this.state.internationalization.title5}>
              {getFieldDecorator("stationId", {
                rules: [
                  {
                    required: true,
                    message: "请选择场站",
                  },
                ],
                initialValue: this.props.stubId == null ? null : this.props.stubId.stationId,
              })(<div><span>{(this.state.stubInfoData && this.state.stubInfoData != null) ? this.state.stubInfoData : ((this.props.stubId && this.props.stubId != null) ? this.props.stubId.stationName : '')}</span><Button type="link"
              onClick={(e) => {
                this.setState({
                  statusLogVisible: true,
                });
              }}>
              {(((this.state.stubInfoData && this.state.stubInfoData != null && this.state.stubInfoData != '')) || (this.props.stubId && this.props.stubId != null)) ? '修改' : '请选择'}
            </Button></div>)}
          </FormItem>) : null}

       
        <FormItem {...formItemLayout} label={this.state.internationalization.title2}>
              {getFieldDecorator("infoType", {
                rules: [
                  {
                    required: true,
                    message: "请选择类型",
                  },
                ],
                initialValue: this.props.stubId == null ? '1' : this.props.stubId.infoType + '',
              })(
              <Select style={{ width: 100 }}>
                <Select.Option key="1" value="1">巡检</Select.Option>
                <Select.Option key="2" value="2">清洁</Select.Option>
                <Select.Option key="3" value="3">保养</Select.Option>
                <Select.Option key="4" value="4">调试</Select.Option>
                <Select.Option key="4" value="5">故障</Select.Option>
                <Select.Option key="4" value="6">验收</Select.Option>
                <Select.Option key="4" value="7">其他</Select.Option>
            </Select>,
              )}
          </FormItem>
          
          <FormItem {...formItemLayout} label={this.state.internationalization.title3}>
              {getFieldDecorator("content", {
                rules: [
                  {
                    required: true,
                    message: "请输入内容",
                  },
                ],
                initialValue: this.props.stubId == null ? null : this.props.stubId.content,
              })(<Input.TextArea />)}
          </FormItem>
          <FormItem {...formItemLayout} label={this.state.internationalization.title4}>
              {getFieldDecorator("payInfo", {
                // rules: [
                //   {
                //     required: true,
                //     message: "请输入费用",
                //   },
                // ],
                initialValue: this.props.stubId == null ? null : this.props.stubId.payInfo,
              })(<Input />)}
          </FormItem>
          <FormItem {...tailFormItemLayout} style={{ marginTop: 14 }}>
            <Button
              type="primary"
              htmlType="submit"
              disabled={this.state.btnDisabled}
              loading={this.state.btnLoading}>
              {this.state.internationalization.btn1}
            </Button>
          </FormItem>
        </Form></div>

        <Modal
          title="选择场站"
          visible={this.state.statusLogVisible}
          footer={[<div key={1} style={{ height: 1 }}></div>]}
          destroyOnClose
          width="800px"
          onCancel={() => {
            this.setState({
              statusLogVisible: false,
            });
          }}>
          <ChooseStation chooseAc={this.chooseAc}  stubIdData={this.state.stubInfoData} />
        </Modal>

        <Modal
          title="选择设备"
          visible={this.state.statusStubIdLogVisible}
          footer={[<div key={1} style={{ height: 1 }}></div>]}
          destroyOnClose
          width="800px"
          onCancel={() => {
            this.setState({
              statusStubIdLogVisible: false,
            });
          }}>
          <ChooseStubId chooseAc={this.chooseStubIdInfo}  stubIdData={this.state.stubIdData} />
        </Modal>
      </div>
    );
  }
}

const EditOrAddStuOpLog = Form.create()(EditOrAddStuOpLogClass);

export default injectIntl(EditOrAddStuOpLog);



// WEBPACK FOOTER //
// ./src/AntD/pages/configurationManagement/stub/editOrAddStuOpLog.js